import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-pro-wa-page',
	templateUrl:'./WaPageProPage.html',
	styles: [],
	styleUrls:['./WaPageProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaPageProPage
{
	mdContent_409 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPage;
\`\`\``;
	mdContent_410 = `\`\`\`java
new WaPage<>()
\`\`\``;
	mdContent_411 = `\`\`\`java
var page = new WaPage<>();

// Header with branding
page.getHeader().add(new WaText<>().setText("My Application"));

// Navigation drawer with tree menu
page.getNavigation().add(buildMenuTree());

// Main content area with router outlet
page.getMain().add(new RouterOutlet<>());

// Aside for secondary content
page.getAside().add(buildTableOfContents());

// Footer
page.getFooter().add(new WaText<>().setText("© 2026 My Corp"));
\`\`\``;
	mdContent_412 = `\`\`\`java
var page = new WaPage<>();
page.setMenuWidth("280px");
page.setMainWidth("1fr");
page.setAsideWidth("300px");
page.setDisableSticky("header");
\`\`\``;
}
